import { z } from "zod";

import { RoleSchema } from "api/schemas/shared";

import { CalculatedDurationWeeksSchema, DurationWeeksSchema } from "./Treatment";

const BaseSchema = z.object({
  activity_type: z.string(),
  comment: z.string().nullable(),
  completed_on: z.string().nullable(),
  id: z.number(),
  overdue: z.boolean(),
  reply: z.string().nullable(),
  title: z.string(),
  user_activity_id: z.number().nullable(),
  user_activity_schedule_id: z.number().nullable(),
});

export const ActivitySchema = z.object({
  ...BaseSchema.shape,
  required: z.boolean(),
  required_at: z.string().nullable(),
});
export type ScheduleWeekActivity = z.infer<typeof ActivitySchema>;

export const ExerciseSchema = z.object({
  ...BaseSchema.shape,
  current_level: z.number(),
  image_url: z.string().nullable(),
  max_level: z.number(),
  premium: z.boolean(),
  video_thumbnail_file_url: z.string().nullable(),
});
export type ScheduleWeekExercise = z.infer<typeof ExerciseSchema>;

export const LessonSchema = z.object({
  ...BaseSchema.shape,
  image_url: z.string().nullable(),
  part: z.number(),
  text_lesson_id: z.number(),
});
export type ScheduleWeekLesson = z.infer<typeof LessonSchema>;

const DaySchema = z.object({
  activities: z.array(ActivitySchema),
  date: z.string(),
  exercises: z.array(ExerciseSchema),
  lessons: z.array(LessonSchema),
});
export type Day = z.infer<typeof DaySchema>;

const DaysSchema = z.record(z.string(), DaySchema);
export type Days = z.infer<typeof DaysSchema>;

const WeekSchema = z.object({
  end_date: z.string(),
  id: z.number(),
  start_date: z.string(),
  week_number: z.number(),
});
export type Week = z.infer<typeof WeekSchema>;

export const ScheduleWeekSchema = z.object({
  calculated_duration_weeks: CalculatedDurationWeeksSchema,
  days: DaysSchema,
  duration_weeks: DurationWeeksSchema,
  week: WeekSchema,
});
export type ScheduleWeek = z.infer<typeof ScheduleWeekSchema>;

const GetScheduleWeekArgsSchema = z.object({
  locale: z.string(),
  patient_id: z.number(),
  treatment_id: z.number(),
  week: z.number(),
  role: RoleSchema,
});
export type GetScheduleWeekArgs = z.infer<typeof GetScheduleWeekArgsSchema>;

export const ActivityTypeSchema = z.enum(["activity", "exercise", "functionality", "lesson", "payment", "report"]);
export type ActivityType = z.infer<typeof ActivityTypeSchema>;
